<template>
  <div class="modal-pdv" :id="'modalAdd' + idModal" tabindex="-1" :class="{'show': modal}">
    <div :id="idModal" class="modal-pdv-content pt-0">
      <div v-if="modelo === 1">
        <div class="container-fluid px-0">
          <div class="lista-adicionais" tabindex="-1">
            <div class="bg-third text-white p-3 pointer fixed-header-top border-bottom" v-for="(g, index) in gruposAds" :key="g.id_grupo_adicional" v-if="g.itens && g.itens.length"
                 v-show="gshow === index" @click="expandir(index)">
              {{g.nome_grupo}}
              <div class="small">
                <span v-if="g.qtd_min > 0 || g.qtd_max > 0">
                  <b>Min:</b> {{g.qtd_min}} - <b>Max:</b> {{g.qtd_max}}
                  <span v-if="!editar"> - </span>
                </span>
                <span v-if="!editar">Selecionados: {{g.selecionados}}</span>
              </div>
            </div>
            <div class="modal-adc height-90 pb-2">
              <div class="px-2 pesquisa-adc" v-if="modal">
                <VueFuse
                    :id="`termAdicional${idModal}`"
                    :list="adicionais"
                    :fuse-opts="options"
                    :map-results="true"
                    :search="term"
                    placeholder="Pesquisar adicional"
                    class="form-control"
                    @fuse-results="handleResults"
                    @keydown.enter.native="addAdicionaisEnter"
                    @fuse-input="(val) => this.term = val"
                />
              </div>
              <div class="row no-gutters mt-2">
                <div class="col-6 px-2 py-2" v-for="a in searchAdc" :key="a.id_tabela_preco + a.id_grupo_adicional">
                  <div class="p-2 rounded shadow-sm overflow-hidden p-adc border" :class="{'bg-adc': a.quantidade > 0}">
                    <div class="small pointer pb-3" @click="toggleAdicionais(a)">
                      <img :src="a.img_produto" class="img-produto" alt="Img Adicional" v-if="a.img_produto">
                      <div class="text-produto">{{a.nome_produto}}</div>
                      <div v-if="a.valor > 0">
                        <span v-if="a.quantidade > 0">R$ {{a.quantidade * a.valor | valor}}</span>
                        <span v-else>R$ {{a.valor}}</span>
                      </div>
                      <div v-else><b>(Grátis)</b></div>
                    </div>
                    <div class="d-flex justify-content-between border rounded text-center text-nowrap" v-if="!disabled">
                      <button class="btn" @click="removeAdicionais(a)">
                        <i class="fa fa-minus"></i>
                      </button>
                      <div class="qtdAdicionais" @click="habilitarQtd(a)">
                        <div class="font-weight-bold" v-if="disableQtd !== a.id_tabela_preco">{{ a.quantidade }}</div>
                        <input :id="`adcInput${a.id_tabela_preco}`" type="tel" class="form-control" v-model="a.quantidade"
                               @blur="changeQtd(a)" @keydown.enter="changeQtd(a)" min="0" v-else/>
                      </div>
                      <button class="btn" @click="addAdicionais(a)">
                        <i class="fa fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <loading v-if="load"/>
                <div class="d-flex justify-content-center align-items-center" v-else-if="!gruposAds.length"
                     style="height: 150px">
                  Este produto não possui adicionais
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-content-footer bg-light p-2 border-top d-flex justify-content-between">
          <button class="btn btn-dark p-3" @click="voltar()">
            <i class="fa fa-chevron-left mr-2"></i>
            <span>Voltar</span>
          </button>
          <button class="btn btn-success p-3" @click="retornarDados" v-if="!disabled">
            <span v-if="gshow + 1 < gruposAds.length">Avançar <i class="fa fa-chevron-right ml-2"></i></span>
            <span v-else>{{editar ? 'Salvar' : 'Adicionar'}} <i class="fa fa-check ml-2"></i></span>
          </button>
        </div>
      </div>

      <div v-if="modelo === 2">
        <div class="container-fluid px-0">
          <div class="lista-adicionais height-100" tabindex="-1">
            <div v-for="(g, index) in gruposAds" :key="g.id_grupo_adicional" v-if="g.itens && g.itens.length">
              <div class="bg-third text-white p-3 pointer border-bottom" :id="`gshow${index}`" v-if="modal">
                <b>{{g.nome_grupo}}</b>
                <div class="small">
                  <span v-if="g.qtd_min > 0 || g.qtd_max > 0"><b>Min:</b> {{g.qtd_min}} - <b>Max:</b> {{g.qtd_max}}<span v-if="!editar"> - </span></span>
                  <span v-if="!editar">Selecionados: {{g.selecionados}}</span>
                </div>
              </div>
              <div class="px-2">
                <div class="row no-gutters my-2">
                  <div class="col-6 p-2" v-for="a in g.itens" :key="a.id_tabela_preco + a.id_grupo_adicional">
                    <div class="p-2 rounded shadow-sm overflow-hidden p-adc border" :class="{'bg-adc': a.quantidade > 0}">
                      <div class="small pointer pb-3" @click="toggleAdicionais(a)">
                        <img :src="a.img_produto" class="img-produto" alt="Img Adicional" v-if="a.img_produto">
                        <div class="text-produto">{{a.nome_produto}}</div>
                        <div v-if="a.valor > 0">
                          <span v-if="a.quantidade > 0">R$ {{a.quantidade * a.valor | valor}}</span>
                          <span v-else>R$ {{a.valor}}</span>
                        </div>
                        <div v-else><b>(Grátis)</b></div>
                      </div>
                      <div class="d-flex justify-content-between border rounded text-center text-nowrap" v-if="!disabled">
                        <button class="btn" @click="removeAdicionais(a)">
                          <i class="fa fa-minus"></i>
                        </button>
                        <div class="qtdAdicionais" @click="habilitarQtd(a)">
                          <div class="font-weight-bold" v-if="disableQtd !== a.id_tabela_preco">{{ a.quantidade }}</div>
                          <input :id="`adcInput${a.id_tabela_preco}`" type="tel" class="form-control" v-model="a.quantidade"
                                 @blur="changeQtd(a)" @keydown.enter="changeQtd(a)" min="0" v-else/>
                        </div>
                        <button class="btn" @click="addAdicionais(a)">
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <loading v-if="load"/>
              <div class="d-flex justify-content-center align-items-center" v-else-if="!gruposAds.length"
                   style="height: 150px">
                Este produto não possui adicionais
              </div>
            </div>
          </div>
        </div>
        <div class="modal-content-footer bg-light p-2 border-top d-flex justify-content-between">
          <button class="btn btn-dark p-3" @click="voltar()">
            <i class="fa fa-chevron-left mr-2"></i>
            <span>Voltar</span>
          </button>
          <button class="btn btn-success p-3" @click="retornarDados" v-if="!disabled">
            {{editar ? 'Salvar' : 'Adicionar'}} <i class="fa fa-check ml-2"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Loading from "../../../components/commons/Loading";
  import VueFuse from 'vue-fuse'

  export default {
    name: "Adicionais",
    components: {Loading, VueFuse},
    props: ['disabled'],
    data() {
      return {
        token: localStorage.getItem('key'),
        load: false,
        idModal: this.$helpers.ID(),
        modal: false,
        editar: false,
        dados: [],
        gruposAds: [],
        gshow: null,
        term: '',
        modelo: 0,
        disableQtd: null,

        adicionais: [],
        searchAdc: [],
        options: {
          shouldSort: true,
          threshold: 0.2,
          location: 0,
          distance: 100,
          maxPatternLength: 32,
          minMatchCharLength: 1,
          keys: [
            "nome_produto",
            "ref_produto",
            "normalized"
          ]
        },
      }
    },
    methods: {
      toggleModal(n, dados) {
        this.modal = n;
        this.$nextTick(() => {
          this.$helpers.toggleModal(n, 'modalAdd' + this.idModal, this.voltar);

          if (n && dados) {
            this.gruposAds = JSON.parse(JSON.stringify(dados));
            this.$nextTick(() => {
              this.expandir(0);
            });

            this.gruposAds.forEach(a => {
              a.selecionados = 0;
            });
          }
        });
      },

      handleResults(r) {
        this.searchAdc = r;
      },

      buscarAdicionais(id, dados) {
        this.load = true;

        this.$http.get('adicionais/produto/' + this.token + '?id_produto=' + id)
          .then(response => {
            this.load = false;

            if (!response.data) {
              return;
            }

            this.gruposAds = response.data;

            this.$nextTick(() => {
              this.expandir(0);

              if (!dados.adicionais.length) {
                return;
              }

              dados.adicionais.forEach((adc) => {
                const g = this.gruposAds.find(g => g.id_grupo_adicional === adc.id_grupo_adicional);

                if (g && g.itens) {
                  const a = g.itens.find(a => a.id_tabela_preco === adc.id_tabela_preco);

                  if (a) {
                    if (adc.id_comanda_produto) {
                      a.id_comanda_produto = adc.id_comanda_produto;
                    }

                    a.quantidade = adc.quantidade;
                    this.addAdicionais(a, true);
                  }
                }
              });
            });

          }, res => {
            this.load = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : "Erro Temporário");
          });
      },

      habilitarQtd(a) {
        this.disableQtd = a.id_tabela_preco;
        this.$nextTick(() => {
          if (this.is_mobile) {
            this.$helpers.focusElement(`adcInput${a.id_tabela_preco}`, true);

          } else {
            this.$helpers.selectElement(`adcInput${a.id_tabela_preco}`);
          }
        });
      },

      changeQtd(a, blur) {
        if (!this.disableQtd) {
          return;
        }

        this.disableQtd = null;

        if (!blur && !isNaN(a.quantidade) && parseInt(a.quantidade) > 0) {
          this.addAdicionais(a, true);

        } else {
          a.quantidade = 0;
          this.removeAdicionais(a, true);
        }
      },

      toggleAdicionais(a) {
        const obj = this.dados.find((obj) => obj.id_grupo_adicional === a.id_grupo_adicional && obj.id_tabela_preco === a.id_tabela_preco);

        if (obj) {
          obj.quantidade = 0;
          this.removeAdicionais(a, true);

        } else {
          this.addAdicionais(a);
        }
      },

      removeAdicionais(a, qtdManual) {
        const obj = this.dados.find((obj) => obj.id_grupo_adicional === a.id_grupo_adicional && obj.id_tabela_preco === a.id_tabela_preco);
        const g = this.gruposAds.find(grupo => grupo.id_grupo_adicional === a.id_grupo_adicional);

        if (obj) {
          const qtdSel = parseInt(g.qtd_sel || '1');
          const qtd = qtdManual ? 0 : (obj.quantidade - qtdSel)
          obj.quantidade = qtd < 0 ? 0 : qtd;
          a.quantidade = obj.quantidade;

          if (!this.editar) {
            g.selecionados = qtdManual ? (this.dados.filter((obj) => obj.id_grupo_adicional === g.id_grupo_adicional).map(p => parseInt(p.quantidade))
                .reduce((prev, next) => prev + next, 0)) : (g.selecionados - qtdSel);
          }

          if (obj.quantidade <= 0) {
            this.dados = this.dados.filter(l => !(l.id_grupo_adicional === a.id_grupo_adicional && l.id_tabela_preco === a.id_tabela_preco));
          }
        }
      },

      addAdicionaisEnter() {
        if (!this.term.trim()) {
          this.retornarDados();

        } else if (this.searchAdc.length === 1) {
          this.addAdicionais(this.searchAdc[0]);
        }
      },

      addAdicionais(a, qtdManual) {
        const g = this.gruposAds.find(grupo => grupo.id_grupo_adicional === a.id_grupo_adicional);
        const qtdSel = parseInt(g.qtd_sel || '1');
        const selecionados = qtdManual ? (this.dados.filter((obj) => obj.id_grupo_adicional === g.id_grupo_adicional && obj.id_tabela_preco !== a.id_tabela_preco)
            .map(p => parseInt(p.quantidade)).reduce((prev, next) => prev + next, 0) + parseInt(a.quantidade)) : (parseInt(g.selecionados) + qtdSel);

        if (!this.editar && g.qtd_max > 0 && selecionados > parseInt(g.qtd_max)) {
          this.$swal("O máximo permitido é " + g.qtd_max);

          if (qtdManual) {
            a.quantidade = 0;
            this.removeAdicionais(a, true);
          }

          return;
        }

        g.selecionados = selecionados;
        const obj = this.dados.find((obj) => obj.id_grupo_adicional === g.id_grupo_adicional && obj.id_tabela_preco === a.id_tabela_preco);

        if (obj) {
          obj.quantidade = qtdManual ? parseInt(a.quantidade) : (obj.quantidade + qtdSel);
          a.quantidade = obj.quantidade;

        } else {
          a.index = this.gruposAds.indexOf(g);
          a.quantidade = qtdManual ? parseInt(a.quantidade) : qtdSel;
          this.dados.push(a);
        }

        if (!this.editar && parseInt(g.qtd_max) === parseInt(g.selecionados)) {
          if (this.modelo === 2) {
            return;
          }

          this.$store.state.load = "Avançando..";

          setTimeout(() => {
            this.$store.state.load = false;

            if ((this.gshow + 1) === this.gruposAds.length) {
              this.retornarDados();

            } else {
              this.expandir(this.gshow + 1);
            }

          }, 500);

        } else if (this.term.length){
          this.clearSearch();
        }
      },

      clearSearch() {
        if (this.modelo === 2) {
          return;
        }

        this.term = "";
        this.searchAdc = this.adicionais;
        const el = document.getElementById("termAdicional" + this.idModal);

        if (el) {
          el.value = "";
        }

        if (!this.is_mobile) {
          this.$helpers.focusElement("termAdicional" + this.idModal);
        }
      },

      voltar() {
        if (this.modelo === 2 || this.gshow === 0) {
          this.toggleModal(false);
          this.$emit('voltar');

        } else {
          this.expandir(this.gshow - 1);
        }
      },

      retornarDados() {
        if (this.modelo === 1 && (this.gshow + 1 < this.gruposAds.length)) {
          this.expandir(this.gshow + 1);

        } else {
          this.dados = this.dados.length ? this.dados.sort((a, b) => a.index - b.index) : [];
          this.toggleModal(false);
          this.$emit('retornar', this.dados)
        }
      },

      expandir(i) {
        if (i < this.gruposAds.length) {
          this.gshow = i;

          if (this.modelo === 1) {
            this.searchAdc = [];
            this.adicionais = this.gruposAds[i].itens;

            this.$nextTick(() => {
              this.$helpers.scrollTop(this.idModal);
              this.clearSearch();
            });

          } else {
            this.$helpers.scrollToView('gshow' + i);
          }
        }
      },

      clear() {
        this.modelo = this.configs.lista_adicionais === '2' ? 2 : 1;
        this.load = true;
        this.gshow = 0;
        this.dados = [];
        this.gruposAds = [];
        this.adicionais = [];
        this.searchAdc = [];
        this.term = "";
      },

      editarAdicionais(dados) {
        this.clear();
        this.editar = true;
        this.toggleModal(true);
        this.buscarAdicionais(dados.produto.id_produto, dados);
      },

      openAdicionais(dados) {
        this.clear();
        this.load = false;
        this.editar = false;
        this.toggleModal(true, dados);
      }
    },

    created() {
      this.$parent.$on('openAdicionais', (dados) => {
        this.openAdicionais(dados);
      });
    },

    computed: {
      configs() {
        return this.$store.state.pdv.json_config;
      }
    },

    filters: {
      valor(value) {
        if (value !== null || value !== undefined) {
          return parseFloat(value).toFixed(2);
        }
      }
    }
  }
</script>

<style scoped>
.p-adc {
  background-color: var(--light);
}

.bg-adc {
  background-color: var(--primary);
  color: #FFFFFF;
}

.bg-adc .btn {
  color: #FFFFFF;
}

.modal-adc.height-90 {
  height: calc(100vh - 222px);
}

.modal-adc {
  padding: 0 7px;
}

.pesquisa-adc {
  padding-top: 16px;
}

.lista-adicionais {
  outline: none;
}

.lista-adicionais.height-100 {
  height: calc(100vh - 138px);
}

.p-adc .img-produto {
  max-width: 100%;
  margin-left: 6px;
  width: 52px;
  height: 52px;
  object-fit: cover;
  float: right;
  border-radius: 6px;
}

.qtdAdicionais {
  cursor: pointer;
  width: 68px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qtdAdicionais input {
  text-align: center;
  width: 68px;
}

@media (max-width: 992px) {
  .fixed-header-top {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1030
  }

  .modal-adc {
    padding: 74px 8px 0;
  }

  .lista-adicionais.height-100 {
    margin-bottom: 0;
  }
}
</style>
